import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1565958e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { id: "about2" }
const _hoisted_3 = { class: "jieti1" }
const _hoisted_4 = { class: "jieti2" }
const _hoisted_5 = { class: "jieti3" }
const _hoisted_6 = { class: "jieti3" }
const _hoisted_7 = { class: "jieti3" }
const _hoisted_8 = { class: "jieti3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dibu" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dibu1" }, " *由于不同皮肤及软组织组织感染疾病的指南/共识建议疗程不同，医生可根据患者感染征象的情况，确定延长疗程时间 ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h20" }, null, -1))
const _hoisted_12 = { class: "bottomBox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_image, {
        width: "2.3733rem",
        height: ".52rem",
        src: require('../assets/newlogo.png')
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_van_popup, {
      show: true,
      style: {"top":"50%"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_image, {
              width: "8.4667rem",
              height: "1.3867rem",
              src: require('../assets/biaoming1.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_image, {
              width: "8.0133rem",
              height: "3.52rem",
              src: require('../assets/biaoming2.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_van_image, {
              width: "7.6533rem",
              height: "1.2933rem",
              src: require('../assets/biaoming3.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_van_image, {
              width: "8.4667rem",
              height: ".9333rem",
              src: require('../assets/biaoming4.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_van_image, {
              width: "8.4667rem",
              height: "2.0933rem",
              src: require('../assets/biaoming5.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_image, {
              width: "7.9867rem",
              height: "1.6267rem",
              src: require('../assets/biaoming6.png')
            }, null, 8, ["src"])
          ]),
          _hoisted_9,
          _hoisted_10
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_van_image, {
            onClick: $options.fangan,
            width: "6.1067rem",
            height: "1.1467rem",
            src: require('../assets/gongbubtn.png')
          }, null, 8, ["onClick", "src"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_toNav, { menu: 3 })
  ], 64))
}